import { takeEvery } from "redux-saga/effects";
import { SHOW_MODAL } from "../types";

// const config = {
//   title: "Use Hook!",
//   content: <h4>Hello everyone!!!</h4>,
// };

export function* showModal() {
  yield undefined;
}

export default function* modalSaga() {
  yield takeEvery(SHOW_MODAL, showModal);
}
